(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-hulkapps-backup"]) return;
  try {
    
  // Update cart when quantity input changes
  function updateCartQuantity(input) {
    const lineIndex = input.getAttribute('data-cart-line');
    const quantity = parseInt(input.value) || 0;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.status === 'bad_request') {
          console.error('Cart update error:', data.message);
          return;
        }
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      });
  }

  // Remove item from cart
  function removeCartItem(lineIndex) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.status === 'bad_request') {
          console.error('Cart update error:', data.message);
          return;
        }
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error removing item:', error);
      });
  }

  function showDiscountError(message) {
    const errorDiv = document.getElementById('discount-error');
    if (errorDiv) {
      errorDiv.style.display = 'flex';
      errorDiv.querySelector('span').textContent = message;
    }
  }

  function hideDiscountError() {
    const errorDiv = document.getElementById('discount-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Handle quantity button clicks
    document.addEventListener('click', function (e) {
      // Handle quantity +/- buttons
      if (e.target.closest('.quantity-btn')) {
        const button = e.target.closest('.quantity-btn');
        const lineIndex = button.getAttribute('data-line-index');
        const change = parseInt(button.getAttribute('data-change'));
        const input = document.querySelector(`input[data-cart-line="${lineIndex}"]`);

        if (input) {
          const currentValue = parseInt(input.value) || 0;
          let newValue;

          // Handle B2B quantity rules
          if (input.classList.contains('quantity-input--b2b')) {
            const min = parseInt(input.getAttribute('data-b2b-min')) || 1;
            const max = input.hasAttribute('data-b2b-max') ? parseInt(input.getAttribute('data-b2b-max')) : null;
            const increment = parseInt(input.getAttribute('data-b2b-increment')) || 1;

            if (change < 0) {
              // Decreasing quantity - allow going to 0 to remove item
              if (currentValue === min) {
                newValue = 0; // Allow removal by going from min to 0
              } else {
                newValue = Math.max(min, currentValue + change);
              }
            } else {
              // Increasing quantity - if at 0, jump to minimum
              if (currentValue === 0) {
                newValue = min;
              } else {
                newValue = currentValue + change;
                if (max) {
                  newValue = Math.min(max, newValue);
                }
              }
            }
          } else {
            // Regular customer - allow quantity to go to 0 (removes item)
            newValue = Math.max(0, currentValue + change);
          }

          input.value = newValue;
          updateCartQuantityButtonStates(input);
          updateCartQuantity(input);
        }
      }

      // Handle remove buttons
      if (e.target.closest('.cart-item__remove')) {
        const button = e.target.closest('.cart-item__remove');
        if (button.classList.contains('cart-discount__remove')) {
          const removeCode = (button.getAttribute('data-discount-code') || '').trim();
          updateDiscountCodes(removeCode);
        } else {
          const lineIndex = button.getAttribute('data-line-index');
          removeCartItem(lineIndex);
        }
      }
    });

    // Handle quantity input changes
    document.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-quantity-input')) {
        // Validate B2B quantity rules before updating
        if (e.target.classList.contains('quantity-input--b2b')) {
          validateB2BQuantity(e.target);
        }
        updateCartQuantityButtonStates(e.target);
        updateCartQuantity(e.target);
      }
    });

    // Update cart quantity button states
    function updateCartQuantityButtonStates(input) {
      const lineIndex = input.getAttribute('data-cart-line');
      const minusBtn = document.querySelector(`.quantity-btn--minus[data-line-index="${lineIndex}"]`);
      const plusBtn = document.querySelector(`.quantity-btn--plus[data-line-index="${lineIndex}"]`);

      if (!minusBtn || !plusBtn) return;

      const currentValue = parseInt(input.value) || 0;

      if (input.classList.contains('quantity-input--b2b')) {
        // B2B quantity button states
        const min = parseInt(input.getAttribute('data-b2b-min')) || 1;
        const max = input.hasAttribute('data-b2b-max') ? parseInt(input.getAttribute('data-b2b-max')) : null;

        // Minus button: disabled only when at 0 (can't go negative)
        minusBtn.disabled = currentValue <= 0;

        // Plus button: disabled when at max (if max exists)
        plusBtn.disabled = max ? currentValue >= max : false;
      } else {
        // Regular customer button states
        minusBtn.disabled = currentValue <= 0;
        plusBtn.disabled = false; // No max limit for regular customers
      }
    }

    // Validate B2B quantity input
    function validateB2BQuantity(input) {
      const value = parseInt(input.value) || 0;
      const min = parseInt(input.getAttribute('data-b2b-min')) || 1;
      const max = input.hasAttribute('data-b2b-max') ? parseInt(input.getAttribute('data-b2b-max')) : null;
      const increment = parseInt(input.getAttribute('data-b2b-increment')) || 1;

      // Allow 0 (removes item) or enforce B2B rules
      if (value === 0) {
        // 0 is valid (removes item)
        return;
      }

      let validValue = Math.max(min, value);
      if (max) {
        validValue = Math.min(max, validValue);
      }

      // Ensure value is a multiple of the increment
      const remainder = (validValue - min) % increment;
      if (remainder !== 0) {
        validValue = validValue - remainder + (remainder >= increment / 2 ? increment : 0);
        validValue = Math.max(min, validValue);
        if (max) {
          validValue = Math.min(max, validValue);
        }
      }

      if (value !== validValue) {
        input.value = validValue;
      }
    }

    // Update cart note
    const cartNote = document.getElementById('cart-note');
    if (cartNote) {
      let timeout;
      cartNote.addEventListener('input', function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: this.value,
            }),
          }).catch((error) => {
            console.error('Error updating note:', error);
          });
        }, 500);
      });
    }

    // Handle discount form submission
    const discountForm = document.getElementById('discount-form');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const discountCode = document.getElementById('discount-code').value.trim();

        if (!discountCode) {
          showDiscountError('Please enter a discount code');
          return;
        }

        // Hide any existing errors
        hideDiscountError();

        // Combine with existing codes in summary
        const existing = Array.from(document.querySelectorAll('.cart-discount__remove[data-discount-code]'))
          .map((el) => (el.getAttribute('data-discount-code') || '').trim())
          .filter(Boolean);
        const combined = Array.from(new Set([...(existing || []), discountCode]));

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            discount: combined.join(','),
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // Success - reload to show updated cart
            window.location.reload();
          })
          .catch((error) => {
            console.error('Error applying discount:', error);
            showDiscountError('Unable to apply discount code. Please try again.');
          });
      });
    }

    // Save cart note explicitly
    const noteSave = document.getElementById('cart-note-save');
    if (noteSave) {
      noteSave.addEventListener('click', function () {
        const noteEl = document.getElementById('cart-note');
        const noteVal = noteEl ? noteEl.value : '';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note: noteVal }),
        })
          .then((r) => r.json())
          .then(() => window.location.reload())
          .catch((err) => console.error('Error saving note:', err));
      });
    }

    // Remove one discount code while preserving others
    function updateDiscountCodes(codeToRemove) {
      // Derive currently applied manual codes from summary buttons
      const codeEls = document.querySelectorAll('.cart-discount__remove[data-discount-code]');
      const codes = Array.from(codeEls)
        .map((el) => (el.getAttribute('data-discount-code') || '').trim())
        .filter(Boolean);

      const remaining = codes.filter((c) => c.toLowerCase() !== codeToRemove.toLowerCase());
      const discountValue = remaining.join(','); // can be empty to clear all

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: discountValue }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showDiscountError('Unable to remove discount. Please try again.');
        });
    }

    // Initialize all quantity button states on page load
    document.querySelectorAll('[data-quantity-input]').forEach((input) => {
      updateCartQuantityButtonStates(input);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Update cart when quantity input changes
  function updateCartQuantity(input) {
    const lineIndex = input.getAttribute('data-cart-line');
    const quantity = parseInt(input.value) || 0;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.status === 'bad_request') {
          console.error('Cart update error:', data.message);
          return;
        }
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      });
  }

  // Remove item from cart
  function removeCartItem(lineIndex) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.status === 'bad_request') {
          console.error('Cart update error:', data.message);
          return;
        }
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error removing item:', error);
      });
  }

  function showDiscountError(message) {
    const errorDiv = document.getElementById('discount-error');
    if (errorDiv) {
      errorDiv.style.display = 'flex';
      errorDiv.querySelector('span').textContent = message;
    }
  }

  function hideDiscountError() {
    const errorDiv = document.getElementById('discount-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Handle quantity button clicks
    document.addEventListener('click', function (e) {
      // Handle quantity +/- buttons
      if (e.target.closest('.quantity-btn')) {
        const button = e.target.closest('.quantity-btn');
        const lineIndex = button.getAttribute('data-line-index');
        const change = parseInt(button.getAttribute('data-change'));
        const input = document.querySelector(`input[data-cart-line="${lineIndex}"]`);

        if (input) {
          const currentValue = parseInt(input.value) || 0;
          let newValue;

          // Handle B2B quantity rules
          if (input.classList.contains('quantity-input--b2b')) {
            const min = parseInt(input.getAttribute('data-b2b-min')) || 1;
            const max = input.hasAttribute('data-b2b-max') ? parseInt(input.getAttribute('data-b2b-max')) : null;
            const increment = parseInt(input.getAttribute('data-b2b-increment')) || 1;

            if (change < 0) {
              // Decreasing quantity - allow going to 0 to remove item
              if (currentValue === min) {
                newValue = 0; // Allow removal by going from min to 0
              } else {
                newValue = Math.max(min, currentValue + change);
              }
            } else {
              // Increasing quantity - if at 0, jump to minimum
              if (currentValue === 0) {
                newValue = min;
              } else {
                newValue = currentValue + change;
                if (max) {
                  newValue = Math.min(max, newValue);
                }
              }
            }
          } else {
            // Regular customer - allow quantity to go to 0 (removes item)
            newValue = Math.max(0, currentValue + change);
          }

          input.value = newValue;
          updateCartQuantityButtonStates(input);
          updateCartQuantity(input);
        }
      }

      // Handle remove buttons
      if (e.target.closest('.cart-item__remove')) {
        const button = e.target.closest('.cart-item__remove');
        if (button.classList.contains('cart-discount__remove')) {
          const removeCode = (button.getAttribute('data-discount-code') || '').trim();
          updateDiscountCodes(removeCode);
        } else {
          const lineIndex = button.getAttribute('data-line-index');
          removeCartItem(lineIndex);
        }
      }
    });

    // Handle quantity input changes
    document.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-quantity-input')) {
        // Validate B2B quantity rules before updating
        if (e.target.classList.contains('quantity-input--b2b')) {
          validateB2BQuantity(e.target);
        }
        updateCartQuantityButtonStates(e.target);
        updateCartQuantity(e.target);
      }
    });

    // Update cart quantity button states
    function updateCartQuantityButtonStates(input) {
      const lineIndex = input.getAttribute('data-cart-line');
      const minusBtn = document.querySelector(`.quantity-btn--minus[data-line-index="${lineIndex}"]`);
      const plusBtn = document.querySelector(`.quantity-btn--plus[data-line-index="${lineIndex}"]`);

      if (!minusBtn || !plusBtn) return;

      const currentValue = parseInt(input.value) || 0;

      if (input.classList.contains('quantity-input--b2b')) {
        // B2B quantity button states
        const min = parseInt(input.getAttribute('data-b2b-min')) || 1;
        const max = input.hasAttribute('data-b2b-max') ? parseInt(input.getAttribute('data-b2b-max')) : null;

        // Minus button: disabled only when at 0 (can't go negative)
        minusBtn.disabled = currentValue <= 0;

        // Plus button: disabled when at max (if max exists)
        plusBtn.disabled = max ? currentValue >= max : false;
      } else {
        // Regular customer button states
        minusBtn.disabled = currentValue <= 0;
        plusBtn.disabled = false; // No max limit for regular customers
      }
    }

    // Validate B2B quantity input
    function validateB2BQuantity(input) {
      const value = parseInt(input.value) || 0;
      const min = parseInt(input.getAttribute('data-b2b-min')) || 1;
      const max = input.hasAttribute('data-b2b-max') ? parseInt(input.getAttribute('data-b2b-max')) : null;
      const increment = parseInt(input.getAttribute('data-b2b-increment')) || 1;

      // Allow 0 (removes item) or enforce B2B rules
      if (value === 0) {
        // 0 is valid (removes item)
        return;
      }

      let validValue = Math.max(min, value);
      if (max) {
        validValue = Math.min(max, validValue);
      }

      // Ensure value is a multiple of the increment
      const remainder = (validValue - min) % increment;
      if (remainder !== 0) {
        validValue = validValue - remainder + (remainder >= increment / 2 ? increment : 0);
        validValue = Math.max(min, validValue);
        if (max) {
          validValue = Math.min(max, validValue);
        }
      }

      if (value !== validValue) {
        input.value = validValue;
      }
    }

    // Update cart note
    const cartNote = document.getElementById('cart-note');
    if (cartNote) {
      let timeout;
      cartNote.addEventListener('input', function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: this.value,
            }),
          }).catch((error) => {
            console.error('Error updating note:', error);
          });
        }, 500);
      });
    }

    // Handle discount form submission
    const discountForm = document.getElementById('discount-form');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const discountCode = document.getElementById('discount-code').value.trim();

        if (!discountCode) {
          showDiscountError('Please enter a discount code');
          return;
        }

        // Hide any existing errors
        hideDiscountError();

        // Combine with existing codes in summary
        const existing = Array.from(document.querySelectorAll('.cart-discount__remove[data-discount-code]'))
          .map((el) => (el.getAttribute('data-discount-code') || '').trim())
          .filter(Boolean);
        const combined = Array.from(new Set([...(existing || []), discountCode]));

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            discount: combined.join(','),
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // Success - reload to show updated cart
            window.location.reload();
          })
          .catch((error) => {
            console.error('Error applying discount:', error);
            showDiscountError('Unable to apply discount code. Please try again.');
          });
      });
    }

    // Save cart note explicitly
    const noteSave = document.getElementById('cart-note-save');
    if (noteSave) {
      noteSave.addEventListener('click', function () {
        const noteEl = document.getElementById('cart-note');
        const noteVal = noteEl ? noteEl.value : '';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note: noteVal }),
        })
          .then((r) => r.json())
          .then(() => window.location.reload())
          .catch((err) => console.error('Error saving note:', err));
      });
    }

    // Remove one discount code while preserving others
    function updateDiscountCodes(codeToRemove) {
      // Derive currently applied manual codes from summary buttons
      const codeEls = document.querySelectorAll('.cart-discount__remove[data-discount-code]');
      const codes = Array.from(codeEls)
        .map((el) => (el.getAttribute('data-discount-code') || '').trim())
        .filter(Boolean);

      const remaining = codes.filter((c) => c.toLowerCase() !== codeToRemove.toLowerCase());
      const discountValue = remaining.join(','); // can be empty to clear all

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: discountValue }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showDiscountError('Unable to remove discount. Please try again.');
        });
    }

    // Initialize all quantity button states on page load
    document.querySelectorAll('[data-quantity-input]').forEach((input) => {
      updateCartQuantityButtonStates(input);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrition-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Progressive enhancement for button-controlled region: smooth height animation and fade control
    const toggleButtons = document.querySelectorAll('.nutrition-detail__toggle-btn');

    toggleButtons.forEach((button) => {
      const regionId = button.getAttribute('aria-controls');
      const body = regionId ? document.getElementById(regionId) : null;
      if (!body) return;
      const list = body.querySelector('.nutrition-detail__ingredients-list');
      const showSpan = button.querySelector('[data-toggle-text-show]');
      const hideSpan = button.querySelector('[data-toggle-text-hide]');
      if (!list || !showSpan || !hideSpan) return;

      const COLLAPSED = 104; // px

      const setCollapsed = () => {
        body.setAttribute('aria-hidden', 'true');
        body.classList.add('is-collapsed');
        list.style.maxHeight = COLLAPSED + 'px';
        button.setAttribute('aria-expanded', 'false');
        showSpan.style.display = 'inline-flex';
        hideSpan.style.display = 'none';
      };

      const expandSmooth = () => {
        body.setAttribute('aria-hidden', 'false');
        body.classList.remove('is-collapsed');
        list.style.maxHeight = COLLAPSED + 'px';
        const target = list.scrollHeight;
        void list.offsetHeight;
        list.style.maxHeight = target + 'px';
        setTimeout(() => {
          list.style.maxHeight = 'none';
        }, 400);
        button.setAttribute('aria-expanded', 'true');
        showSpan.style.display = 'none';
        hideSpan.style.display = 'inline-flex';
      };

      const collapseSmooth = () => {
        const current = list.scrollHeight;
        list.style.maxHeight = current + 'px';
        void list.offsetHeight;
        list.style.maxHeight = COLLAPSED + 'px';
        setTimeout(() => {
          body.setAttribute('aria-hidden', 'true');
          body.classList.add('is-collapsed');
          button.setAttribute('aria-expanded', 'false');
          showSpan.style.display = 'inline-flex';
          hideSpan.style.display = 'none';
        }, 400);
      };

      // Initialize collapsed with fade
      setCollapsed();

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          collapseSmooth();
        } else {
          expandSmooth();
        }
      });

      // Re-evaluate on layout changes
      let timer;
      const recheck = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          if (expanded) {
            list.style.maxHeight = 'none';
          } else {
            setCollapsed();
          }
        }, 150);
      };
      window.addEventListener('resize', recheck);
      document.addEventListener('visibilitychange', recheck);
      window.addEventListener('orientationchange', recheck);
      window.addEventListener('load', recheck);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
